// removed by extract-text-webpack-plugin
module.exports = {"root":"_3r9hh0o"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/Accessibility/ScreenReaderSkipLink.less
 ** module id = 710
 ** module chunks = 0
 **/